export const language: any = {
  title: "Hey! Cooker အသိုင်းအဝိုင်း",
  follow: "လိုက်နာပါ",
  follower: "လိုက်နာသူများ",
  post_share: "မျှဝေထားသော ပို့စ်",
  like_share: "နှစ်သက်မှု",
  report: "ချိုးဖောက်မှု တိုင်ကြားရန်",
  delete_post: "ပို့စ်ဖျက်ရန်",
  delete_comment: "မှတ်ချက်ဖျက်ရန်",
  confirm_report: "ဤပို့စ်တွင် အသိုင်းအဝိုင်း လမ်းညွှန်ချက်များကို ချိုးဖောက်သော အကြောင်းအရာများ ပါဝင်သည်ဟု သေချာပါသလား။ တိုင်ကြားမှု အောင်မြင်ပြီးနောက်၊ ဤပို့စ်ကို သင်မမြင်ရတော့ပါ။",
  confirm_report_comment: "ဤမှတ်ချက်သည် အသိုင်းအဝိုင်း လမ်းညွှန်ချက်များကို ချိုးဖောက်သည်ဟု သေချာပါသလား။",
  toats_report: "ချိုးဖောက်မှု တိုင်ကြားပေးသည့်အတွက် ကျေးဇူးတင်ပါသည်။ သင်၏တိုင်ကြားချက်ကို စစ်ဆေးနေပါသည်။",
  confirm_delete: "ဤပို့စ်ကို ဖျက်လိုပါသလား။",
  confirm_delete_comment: "ဤမှတ်ချက်ကို ဖျက်ရန် သေချာပါသလား။",
  toast_delete: "ဖျက်ခြင်းအောင်မြင်ပါသည်!",
  text_yes: "ဟုတ်ကဲ့",
  text_no: "မဟုတ်ပါ",
  create: {
    title: "ပိုစ့်တင်မည် - Hey!Cooker အသိုင်းအဝိုင်း",
    content_placeholder: "သင့်ပိုစ့်အကြောင်းအရာကိုရေးပါ",
    submit: "ယခုမျှဝေရန်",
    add_image_by_camera: "ကင်မရာဖြင့် ဓာတ်ပုံရိုက်ရန်",
    add_image_by_gallery: "ဓာတ်ပုံရွေးရန်",
    add_video_by_camera: "ဗီဒီယိုရိုက်ရန်",
    add_video_by_gallery: "ဗီဒီယိုရွေးရန်",
  },
  detail: {
    shared: "မျှဝေပြီး",
    shared_community: "အသိုင်းအဝိုင်းနှင့် ဓာတ်ပုံ (ဗီဒီယို) မျှဝေခဲ့သည်"
  },
  follwed: "နောက်လိုက်ပြီး",
  comment: {
    placeholder: "ကျေးဇူးပြု၍ မှတ်ချက်ရေးပါ",
    submit: "ပို့ရန်",
    nodata: "ဤနေရာတွင်မှတ်ချက်ရေးပြီး ပထမဆုံးမှတ်ချက်ရေးသူဖြစ်ပါ",
    load_more: "နောက်ထပ်မှတ်ချက်များကြည့်ရန်",
    not_login: "မှတ်ချက်ရေးရန် ကျေးဇူးပြု၍ လော့ဂ်အင်ဝင်ပါ",
    delete: "မှတ်ချက်ကို ဖျက်ရန်",
    delete_confirm: "ဤမှတ်ချက်ကို ဖျက်ရန် သေချာပါသလား?",
    delete_success: "မှတ်ချက်ကို အောင်မြင်စွာ ဖျက်ပြီးပါပြီ",
    report: "รายงานการละเมิด",
    report_confirm: "ဤမှတ်ချက်သည် အသိုင်းအဝိုင်း ညွှန်ကြားချက်များကို ချိုးဖောက်သည်ဟု သေချာပါသလား?",
    report_success: "သင့်၏รายงานကိုစစ်ဆေးနေပါသည်။",
  },
  bottom_navigation: "အသိုင်းအဝိုင်း",
  shared_post: "ပိုစ်တင်ကို မျှဝေခဲ့သည်",
};
